import React, { useEffect, useState } from "react";
import spinwheelService from "./services/apiServices/SpinWheelService";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./SpinWheel.css";
import pointer from "./assests/icons/spin-wheel-pointer.svg";
import axios from "axios";
import LazyImage from "./LazyImage";
import confetti from "canvas-confetti";
// import { toast, ToastContainer } from "react-toastify";
import { ToastContainer, toast } from "react-toastify";

import countryCode from "./countryCode";
import QRCode from "react-qr-code";
import winDecoration from "./assests/icons/win-card-decoration.com.svg";
import giftBox from "./assests/icons/gift-box.svg";
import { showErrorToast, showSuccessToast } from "./Notification";
import { companyName, senderId, smsApiKey, templateId } from "./config";

const SpinWheel = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [bannerImage, setBannerImage] = useState();
  const [spinWheelData, setSpinWheelData] = useState();
  const [wheelStatus, setWheelStatus] = useState();
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  
  // Extract docId from query parameter instead of path
  const searchParams = new URLSearchParams(location.search);
  const docId = searchParams.get("id") || location.pathname.split("/").pop();
  
  const [showTermsAndConditionPopup, setTermsAndConditionPopup] =
    useState(false);
  const [termsAndCondition, setTermsAndCondition] = useState();
  const [spinWheelLogo, setSpinwheelLogo] = useState();
  const agreeStatus = localStorage.getItem("isAgree");
  const [prizes, setPrizes] = useState([]);

  const [resultWinOrLose, setResultWinOrLose] = useState(-1);
  const [rotationAngle, setRotationAngle] = useState(0);
  const [totalSpins, setTotalSpins] = useState();
  const [spinWheelResult, setSpinWheelResult] = useState();
  const [finalResult, setFinalResult] = useState();
  const [showWinOrLosePopup, setWinOrLosePopup] = useState(false);
  const [showPausePopup, setShowPausePopup] = useState(false);

  const [resendTime, setResendTime] = useState(60);
  const [isResendActive, setIsResendActive] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [otp, setOtp] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [otpVerify, setOtpVerify] = useState("");

  const [messageResult, setMessageResult] = useState(null);

  const [selectedValue, setSelectedValue] = useState("+91");

  // Referral state variables
  const [firstReferralName, setFirstReferralName] = useState("");
  const [firstReferralPhone, setFirstReferralPhone] = useState("");
  const [secondReferralName, setSecondReferralName] = useState("");
  const [secondReferralPhone, setSecondReferralPhone] = useState("");

  // Testimonials state
  const [showTestimonials, setShowTestimonials] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  // State to track if terms popup was opened from login popup
  const [termsOpenedFromLogin, setTermsOpenedFromLogin] = useState(false);

  // Referral submission state
  const [referralSubmitted, setReferralSubmitted] = useState(() => {
    const saved = localStorage.getItem(`referralSubmitted_${docId}`);
    return saved ? JSON.parse(saved) : false;
  });

  // Persist referralSubmitted to localStorage
  useEffect(() => {
    localStorage.setItem(`referralSubmitted_${docId}`, JSON.stringify(referralSubmitted));
  }, [referralSubmitted, docId]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const fetchWheelData = await spinwheelService.getSpinWheelDetail(docId);
        setSpinWheelData(fetchWheelData.data);
        setWheelStatus(fetchWheelData?.data?.spinWheel?.status);
        setBannerImage(fetchWheelData?.data?.spinWheel?.bannerUrl);
       setTestimonials(fetchWheelData.data.testimonials || []);
      } catch (error) {
        console.log(error?.response?.data || "Error fetching wheel data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [docId]);

  // Update page title and meta tags when spinWheelData is loaded
  useEffect(() => {
    if (spinWheelData) {
      const wheelTitle = spinWheelData?.spinWheel?.wheelTitle || "Spin & Win";
      const companyNameFromData = spinWheelData?.spinWheel?.companyName || companyName;
      
      // Update page title
      document.title = `${wheelTitle} | ${companyNameFromData}`;
      
      // Update meta description
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", `${companyNameFromData} - ${wheelTitle}. Spin the wheel and win amazing prizes!`);
      }
      
      // Update or create og:title meta tag
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.setAttribute('content', `${wheelTitle} | ${companyNameFromData}`);
      
      // Update or create og:description meta tag
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (!ogDescription) {
        ogDescription = document.createElement('meta');
        ogDescription.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescription);
      }
      ogDescription.setAttribute('content', `${companyNameFromData} - ${wheelTitle}. Spin the wheel and win amazing prizes!`);
      
      // Update or create og:image meta tag (for social media sharing)
      let ogImage = document.querySelector('meta[property="og:image"]');
      if (!ogImage) {
        ogImage = document.createElement('meta');
        ogImage.setAttribute('property', 'og:image');
        document.head.appendChild(ogImage);
      }
      ogImage.setAttribute('content', spinWheelData?.spinWheel?.bannerUrl || '');
      
      // Update or create og:url meta tag
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (!ogUrl) {
        ogUrl = document.createElement('meta');
        ogUrl.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrl);
      }
      ogUrl.setAttribute('content', window.location.href);
      
      // Update or create Twitter Card meta tags
      let twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (!twitterTitle) {
        twitterTitle = document.createElement('meta');
        twitterTitle.setAttribute('name', 'twitter:title');
        document.head.appendChild(twitterTitle);
      }
      twitterTitle.setAttribute('content', `${wheelTitle} | ${companyNameFromData}`);
      
      // Update or create twitter:description meta tag
      let twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (!twitterDescription) {
        twitterDescription = document.createElement('meta');
        twitterDescription.setAttribute('name', 'twitter:description');
        document.head.appendChild(twitterDescription);
      }
      twitterDescription.setAttribute('content', `${companyNameFromData} - ${wheelTitle}. Spin the wheel and win amazing prizes!`);
      
      // Update or create twitter:image meta tag
      let twitterImage = document.querySelector('meta[name="twitter:image"]');
      if (!twitterImage) {
        twitterImage = document.createElement('meta');
        twitterImage.setAttribute('name', 'twitter:image');
        document.head.appendChild(twitterImage);
      }
      twitterImage.setAttribute('content', spinWheelData?.spinWheel?.bannerUrl || '');
    }
  }, [spinWheelData]);

  // Update favicon when spinWheelLogo is loaded
  useEffect(() => {
    if (spinWheelLogo) {
      // Update favicon
      let favicon = document.querySelector('link[rel="icon"]');
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'icon');
        document.head.appendChild(favicon);
      }
      favicon.setAttribute('href', spinWheelLogo);
      
      // Also update apple-touch-icon
      let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
      if (appleTouchIcon) {
        appleTouchIcon.setAttribute('href', spinWheelLogo);
      }
    }
  }, [spinWheelLogo]);

  const handleTermsAndCondition = () => {
    // Check if login popup is currently open
    if (showLoginPopup) {
      setTermsOpenedFromLogin(true);
      setShowLoginPopup(false);
    } else {
      setTermsOpenedFromLogin(false);
    }
    setTermsAndConditionPopup(true);
  };
  const handleUpdateTermsAndCondition = () => {
    setTermsAndConditionPopup(false);
    // If terms was opened from login popup, reopen the login popup
    if (termsOpenedFromLogin) {
      setShowLoginPopup(true);
      setTermsOpenedFromLogin(false);
    }
  };

  const handleAgreeFromTermsAndCondition = () => {
    // setAgree(true)
    setIsChecked(true);
    localStorage.setItem("isAgree", "true");
    setTermsAndConditionPopup(false);
    // If terms was opened from login popup, reopen the login popup
    if (termsOpenedFromLogin) {
      setShowLoginPopup(true);
      setTermsOpenedFromLogin(false);
    }
  };

  const handleClosePopup = async (response) => {
    const fetchWheelData = await spinwheelService.getSpinWheelDetail(docId);

    let spinWheelDataObj = fetchWheelData.data;
    let spinWheelStatus = fetchWheelData?.data?.spinWheel?.status;
    handleSpinClickAfterLogin(response.uid, spinWheelDataObj, spinWheelStatus);
  };

  const handleCloseWinPopup = () => {
    setWinOrLosePopup(false);
    setReferralSubmitted(false);
    localStorage.removeItem(`referralSubmitted_${docId}`);
    // Don't remove referralsList - keep it to maintain form submission state
    setFirstReferralName("");
    setFirstReferralPhone("");
    setSecondReferralName("");
    setSecondReferralPhone("");
  };

  //   --------------- spin wheel ------------------------------------

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const fetchWheelData = await spinwheelService.getSpinWheelDetail(docId);
        setSpinWheelData(fetchWheelData.data);
        setWheelStatus(fetchWheelData?.data?.spinWheel?.status);
        setBannerImage(fetchWheelData?.data?.spinWheel?.bannerUrl);

        getSpinResultLoggedInUser();
      } catch (error) {
        console.log(error?.response?.data || "Error fetching wheel data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [docId]);

  //   ------- terms and condition ----------------------------
  useEffect(() => {
    const response = async () => {
      setLoading(true);
      try {
        const fetchData = await spinwheelService.getSpinWheelGeneralInfo();
        const data = fetchData.data;
        setSpinwheelLogo(data.spinWheelLogo);
        setTermsAndCondition(data.termsAndCondition);
      } catch (error) {
        console.log(error.response.data);
      } finally {
        setLoading(false);
      }
    };
    response();
  }, []);

  //   --------- spin wheel --------------------------

  const handleImageLoad = (index) => {
    setPrizes((prevPrizes) =>
      prevPrizes.map((prize, i) =>
        i === index ? { ...prize, loaded: true } : prize
      )
    );
  };

  // Celebration effect for winning
  const triggerCelebration = () => {
    // Multiple bursts of confetti
    const duration = 4000; // Increased to 4 seconds
    const animationEnd = Date.now() + duration;

    const randomInRange = (min, max) => {
      return Math.random() * (max - min) + min;
    };

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);

      // Center burst
      confetti({
        particleCount,
        angle: 90,
        spread: 45,
        origin: { x: 0.5, y: 0.5 },
        velocity: randomInRange(10, 30),
        gravity: 2.5, // Increased from 1 to make particles fall faster
        ticks: 200, // Reduced from 300 to make them fall quicker
        zIndex: 1000,
      });

      // Left side burst
      confetti({
        particleCount: particleCount * 0.5,
        angle: 45,
        spread: 60,
        origin: { x: 0.2, y: 0.3 },
        velocity: randomInRange(15, 35),
        gravity: 2.8, // Increased from 1.2
        ticks: 200, // Reduced from 300
        zIndex: 1000,
      });

      // Right side burst
      confetti({
        particleCount: particleCount * 0.5,
        angle: 135,
        spread: 60,
        origin: { x: 0.8, y: 0.3 },
        velocity: randomInRange(15, 35),
        gravity: 2.8, // Increased from 1.2
        ticks: 200, // Reduced from 300
        zIndex: 1000,
      });
    }, 50);
  };

  const getSpin = (spinWheelData, spinCount) => {
    if (spinWheelData?.gifts != undefined) {
      let prizesArray = [
        {
          label: spinWheelData?.gifts[0]?.giftName,
          image: spinWheelData?.gifts[0]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[1]?.giftName,
          image: spinWheelData?.gifts[1]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[2]?.giftName,
          image: spinWheelData?.gifts[2]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[3]?.giftName,
          image: spinWheelData?.gifts[3]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[4]?.giftName,
          image: spinWheelData?.gifts[4]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[5]?.giftName,
          image: spinWheelData?.gifts[5]?.giftImageUrl,
          loaded: false,
        },
      ];
      // setPrizes(prizesArray);

      // if (spinning) {
      let spNumber = spinCount + 1;

      if (spNumber > 1000) {
        spNumber = spNumber % 1000;
      }

      let index = 0;
      let tryAgainIndex;
      let winIndex = -1;
      spinWheelData?.gifts.forEach((gift) => {
        if (gift?.giftNumber.includes(spNumber)) {
          setResultWinOrLose(index);
          winIndex = index;
          resultData(index);
          // alert("Won "+spinWheelData?.gifts[index]?.giftName)
        }

        if (gift?.resultType == false) {
          tryAgainIndex = index;
        }
        index = index + 1;
      });

      //   alert(`winindex `+ winIndex)
      //   alert(`tryindex `+ tryAgainIndex)

      if (winIndex != -1) {
        const segmentAngle = 360 / prizesArray.length;
        // Calculate the center of the winning segment
        const winningAngle = (winIndex * segmentAngle) + (segmentAngle / 2);
        // Rotate to point the winning segment to the top (add extra rotations for smooth spinning)
        const totalRotation = 3600 - winningAngle;
        console.log("Win Index:", winIndex, "Winning Angle:", winningAngle, "Total Rotation:", totalRotation);
        setRotationAngle(totalRotation);
      } else {
        const segmentAngle = 360 / prizesArray.length;
        const tryAgainAngle = (tryAgainIndex * segmentAngle) + (segmentAngle / 2);
        const totalRotation = 3600 - tryAgainAngle;

        console.log("Try Again Index:", tryAgainIndex, "Try Again Angle:", tryAgainAngle, "Total Rotation:", totalRotation);
        setRotationAngle(totalRotation);

        setResultWinOrLose(-1);
        resultData(-1);
      }
      // }
    }
  };

  useEffect(() => {
    if (spinWheelData?.gifts != undefined) {
      let prizesArray = [
        {
          label: spinWheelData?.gifts[0]?.giftName,
          image: spinWheelData?.gifts[0]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[1]?.giftName,
          image: spinWheelData?.gifts[1]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[2]?.giftName,
          image: spinWheelData?.gifts[2]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[3]?.giftName,
          image: spinWheelData?.gifts[3]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[4]?.giftName,
          image: spinWheelData?.gifts[4]?.giftImageUrl,
          loaded: false,
        },
        {
          label: spinWheelData?.gifts[5]?.giftName,
          image: spinWheelData?.gifts[5]?.giftImageUrl,
          loaded: false,
        },
      ];
      setPrizes(prizesArray);
    }
  }, [spinWheelData]);
  //   useEffect(() => {
  //     // if (spinWheelData?.gifts != undefined) {
  //     //   let prizesArray = [
  //     //     {
  //     //       label: spinWheelData?.gifts[0]?.giftName,
  //     //       image: spinWheelData?.gifts[0]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //     {
  //     //       label: spinWheelData?.gifts[1]?.giftName,
  //     //       image: spinWheelData?.gifts[1]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //     {
  //     //       label: spinWheelData?.gifts[2]?.giftName,
  //     //       image: spinWheelData?.gifts[2]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //     {
  //     //       label: spinWheelData?.gifts[3]?.giftName,
  //     //       image: spinWheelData?.gifts[3]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //     {
  //     //       label: spinWheelData?.gifts[4]?.giftName,
  //     //       image: spinWheelData?.gifts[4]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //     {
  //     //       label: spinWheelData?.gifts[5]?.giftName,
  //     //       image: spinWheelData?.gifts[5]?.giftImageUrl,
  //     //       loaded: false,
  //     //     },
  //     //   ];
  //     //   setPrizes(prizesArray);
  //     //   console.log(prizes);

  //     //   if (spinning) {
  //     //     let spNumber = totalSpins + 1;

  //     //     if (spNumber > 1000) {
  //     //       spNumber = spNumber % 1000;
  //     //     }

  //     //     let index = 0;
  //     //     let tryAgainIndex;
  //     //     let winIndex = -1;
  //     //     spinWheelData?.gifts.forEach((gift) => {
  //     //       if (gift?.giftNumber.includes(spNumber)) {
  //     //         setResultWinOrLose(index);
  //     //         winIndex = index;
  //     //         resultData(index);
  //     //         // alert("Won "+spinWheelData?.gifts[index]?.giftName)
  //     //       }

  //     //       if (gift?.resultType == false) {
  //     //         tryAgainIndex = index;
  //     //       }
  //     //       index = index + 1;
  //     //     });

  //     //     if (winIndex != -1) {
  //     //       const segmentAngle = 360 / prizesArray.length;
  //     //       const winningAngle =
  //     //         360 - winIndex * segmentAngle - segmentAngle / 2 - 60;
  //     //       console.log(winningAngle);
  //     //       setRotationAngle(winningAngle + 2080);
  //     //     } else {
  //     //       const segmentAngle = 360 / prizesArray.length;
  //     //       const winningAngle =
  //     //         360 - tryAgainIndex * segmentAngle - segmentAngle / 2 - 60;

  //     //       console.log(winningAngle);
  //     //       setRotationAngle(winningAngle + 2080);
  //     //       setResultWinOrLose(-1);
  //     //       resultData(-1);
  //     //     }
  //     //   }
  //     // }
  //   }, [ spinning]);

  const resultData = async (result) => {
    console.log(result);
    let giftResult;
    let userUid = sessionStorage.getItem("uid");
    setSpinWheelResult(result);
    if (result == -1) {
      spinWheelData?.gifts.map((gift) => {
        if (gift.resultType == false) {
          giftResult = gift;
        }
      });
    } else {
      giftResult = spinWheelData?.gifts[result];
    }

    console.log(giftResult);
    const resultObj = {
      spinWheelDocId: docId,
      userDocId: userUid,
      days: spinWheelData?.spinWheel?.giftExpiryDays,
      giftImageUrl: giftResult?.giftImageUrl,
      giftItem: giftResult?.giftName,
      result: giftResult?.resultType,
    };

    try {
      const getResult = await spinwheelService.spinWheelResultAdd(resultObj);
      console.log(getResult);
      setFinalResult(getResult.data);
      // Wait for spin animation to complete (7 seconds) then show popup with celebration
      setTimeout(() => {
        // Only trigger celebration for winners
        if (giftResult?.resultType === true) {
          triggerCelebration();
        }
        setWinOrLosePopup(true);
      }, 7000);
    } catch (error) {
      console.log(error.response.data);
    }
  };

  //   ----------- Spin -------------------------------

  const getSpinResultLoggedInUser = async () => {
    let userUid = sessionStorage.getItem("uid");
    if (userUid != undefined) {
      const getResult = {
        uid: userUid,
        spinWheelId: docId,
      };
      const fetchData = await spinwheelService.spinWheelResult(getResult);
      console.log(fetchData.data);
      setFinalResult(fetchData.data);
      if (fetchData.data?.resultObj != undefined) {
        setWinOrLosePopup(true);
      }
    }
  };
  const handleSpinClick = async (spinWheelStatus) => {
    setLoading(true);
    let userUid = sessionStorage.getItem("uid");
    if (!userUid) {
      setLoading(false);
      setShowLoginPopup(true);
    } else if (userUid) {
      setLoading(false);

      const getResult = {
        uid: userUid,
        spinWheelId: docId,
      };
      const response = async () => {
        try {
          const fetchData = await spinwheelService.spinWheelResult(getResult);
          console.log(fetchData.data);
          setFinalResult(fetchData.data);
          if (fetchData.data?.resultObj != undefined) {
            setWinOrLosePopup(true);
          } else {
            if (spinWheelStatus) {
              const response = await spinwheelService.getTotalSpinCount(docId);
              const data = response?.data?.totalSpins;
              console.log(data);
              setTotalSpins(data);
              if (data != undefined) {
                // setSpinning(true);
                getSpin(spinWheelData, data);
              }
            }
            setShowPausePopup(!spinWheelStatus);
          }
        } catch (error) {
          console.log(error.response.data);
        }
      };
      response();
    }
  };

const handleSpinClickAfterLogin = async (
    userId,
    spinWheelDataObj,
    spinWheelStatus
  ) => {
    const getResult = {
      uid: userId,
      spinWheelId: docId,
    };
    // setLoading(true);

    try {
      const fetchData = await spinwheelService.spinWheelResult(getResult);
      console.log(fetchData.data);
      setFinalResult(fetchData.data);
      if (fetchData.data?.resultObj != undefined) {
        setShowLoginPopup(false);
        setWinOrLosePopup(true);
      } else {
        setShowLoginPopup(false);

        setShowPausePopup(!spinWheelStatus);
        if (spinWheelStatus) {

          const response = await spinwheelService.getTotalSpinCount(docId);
          const data = response?.data?.totalSpins;

          setTotalSpins(data);
          if (data != undefined) {
            getSpin(spinWheelData,data)

          }
        }
      }
    } catch (error) {
      console.log(error.response.data);
    } finally {
      setLoading(false);
    }
  };

  // const handleSpinClickAfterLogin = async (
  //   userId,
  //   spinWheelDataObj,
  //   spinWheelStatus
  // ) => {
  //   const getResult = {
  //     uid: userId,
  //     spinWheelId: docId,
  //   };
  //   // setLoading(true);

  //   try {
  //     const fetchData = await spinwheelService.spinWheelResult(getResult);
  //     console.log(fetchData.data);
  //     setFinalResult(fetchData.data);
  //     if (fetchData.data?.resultObj != undefined) {
  //       setShowLoginPopup(false);
  //       setWinOrLosePopup(true);
  //     } else {
  //       setShowLoginPopup(false);

  //       setShowPausePopup(!spinWheelStatus);
  //       if (spinWheelStatus) {
  //         const response = await spinwheelService.getTotalSpinCount(docId);
  //         const data = response?.data?.totalSpins;

  //         setTotalSpins(data);
  //         if (data != undefined) {
  //           getSpin(spinWheelData, data);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error.response.data);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //   ---------------------- Login Modal -----------------------------

  useEffect(() => {
    let timer = null;
    if (resendTime > 0 && isResendActive) {
      timer = setTimeout(() => {
        setResendTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (resendTime === 0 && isResendActive) {
      setIsResendActive(false);
    }

    return () => clearTimeout(timer);
  }, [resendTime, isResendActive]);

  const generateOtp = () => {
    const otp = Math.floor(100000 + Math.random() * 900000);
    return otp.toString(); // Convert to string if needed
  };

  const validateFields = () => {
    if (!name.trim()) {
      showErrorToast("Name is required");
      return false;
    }
    // if (!selectedCountryCode) {
    //     showErrorToast("Country code is required");
    //   return false;
    // }
    if (!phoneNumber || phoneNumber.length < 10) {
      showErrorToast("Enter a valid phone number");
      return false;
    }
    return true;
  };

  const handleButton = async () => {
    if (!validateFields()) return;

    if (buttonStatus) {
    } else {
    }
  };

  const verifyOtp = async () => {
    if (!validateFields()) return;
    setIsDisabled(true);
    try {
      if (otp == otpVerify) {
        // toast.success("OTP verified successfully");
        showSuccessToast("OTP verified successfully");

        const userObj = [
          {
            name: name,
            phoneNumber: phoneNumber,
            countryCode: "+91",
            isReferred: false,
            referralId: null,
            spinWheelId: docId,
          }
        ];

        const response = await spinwheelService.userCreation(userObj);
        console.log(`response: ${response.data}`);

        const userData = response.data.results[0].data;
        const userId = userData.uid;

        sessionStorage.setItem("phoneNumber", userData.phoneNumber);
        sessionStorage.setItem("userDocId", userData.id);
        sessionStorage.setItem("isReferred", JSON.stringify(userData.isReferred));
        sessionStorage.setItem("referralsList", JSON.stringify(userData.referralsList || []));
        sessionStorage.setItem("countryCode", userData.countryCode);
        sessionStorage.setItem("uid", userId);
        sessionStorage.setItem("userName", userData.name);
        sessionStorage.setItem("isLoggedIn", "true");

        // closeModal(response.data);
        setShowLoginPopup(false);

        handleClosePopup({ uid: userId });
      } else {
        showErrorToast("Verification failed - Incorrect OTP");
      }
    } catch (error) {
      showErrorToast(
        error.response?.data || error.message || "OTP verification failed"
      );
      console.error(error.response?.data || error.message);
    } finally {
      setIsDisabled(false);
    }
  };

  const ReferralUserDetails = async () => {
    try{
      const userDocId = sessionStorage.getItem("userDocId");
      
      const referrals = [
        {
          name: firstReferralName,
          phoneNumber: firstReferralPhone,
          countryCode: "+91",
          isReferred: true,
          referralId: userDocId,
        },
        {
          name: secondReferralName,
          phoneNumber: secondReferralPhone,
          countryCode: "+91",
          isReferred: true,
          referralId: userDocId,
          spinWheelId: docId,
        }
      ];

      const referralObj = referrals.filter(ref => ref.name && ref.phoneNumber);

      if (referralObj.length > 0) {
        const response = await spinwheelService.userCreation(referralObj);
        console.log(`referral response: ${response.data}`);
        
        // Store the referral list in sessionStorage
        sessionStorage.setItem("referralsList", JSON.stringify(response.data.results || []));
        
        // Check if referrals were created successfully
        const referralList = response.data.results || [];
        if (referralList.length > 0) {
          showSuccessToast("Referral details submitted successfully!");
          setReferralSubmitted(true);
        } else {
          showErrorToast("Failed to create referral users");
        }
      }

    } catch(error) {
      console.error("Error in referral details:", error);
      showErrorToast("Error saving referral details");
    }
  }



  const sendOtp = async () => {
    // if (!validateFields()) return;

    setResendTime(60); // Reset timer to 60 seconds
    setIsResendActive(true); // Start the timer
    let otpCode = generateOtp();
//  setWinOrLosePopup(true)
setShowLoginPopup(true)
    setOtpVerify(otpCode);
    setButtonLoading(true);
    try {
     
      
      const result = await axios.get(
        `https://sms.promptbulksms.com/api/smsapi?key=${smsApiKey}&route=1&sender=${senderId}&number=${phoneNumber}&sms=Dear Customer, Your OTP for registering with ${companyName} is ${otpCode}. Valid for 3 minutes. Please do not share this OTP.&templateid=${templateId}`
      );
      // const result = await spinwheelService.sendOtpViaApi(phoneNumber,otpCode)
      console.log(result);
      setMessageResult(result.data);
      setButtonStatus(true);
        // setShowLoginPopup(true);

      showSuccessToast("OTP sent to your phone");
    } catch (error) {
      console.error("Error sending OTP:", error);
      //   toast.error("Error sending OTP. Please try again.");
    } finally {
      setButtonLoading(false);
    }
  };

  const handlePhoneNumber = (e) => {
    const newPhoneNumber = e.target.value.replace(/\D/g, "");
    if (newPhoneNumber.length <= 10) {
      setPhoneNumber(newPhoneNumber);
    }
  };
  const handleOtp = (e) => {
    const otpNumber = e.target.value.replace(/\D/g, "");
    setOtp(otpNumber);
  };
  //   const handleCountryCodeChange = (selectedValue) => {
  //     setSelectedCountryCode(selectedValue);
  //   };

  const handleResendOTP = async () => {
    if (isResendActive) return;

    setResendTime(60); // Reset timer to 60 seconds
    setIsResendActive(true); // Start the timer

    let otpCode = generateOtp();

    setOtpVerify(otpCode);

    try {
      const result = await axios.get(
        `https://sms.promptbulksms.com/api/smsapi?key=${smsApiKey}&route=1&sender=${senderId}&number=${phoneNumber}&sms=Dear customer, ${otpCode} is your one time password (OTP) for Spin %26 Win Wheel. Please do not share the OTP with others. Regards, ${companyName}&templateid=${templateId}`
      );

      // const result = await spinwheelService.sendOtpViaApi(phoneNumber,otpCode)

      console.log(result);
      setMessageResult(result.data);
      setButtonStatus(true);
      toast.success("OTP sent to your phone");
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Error sending OTP. Please try again.");
    }
  };

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    // if (onSelectChange) {
    //   onSelectChange(newValue); // Notify parent of dropdown change
    // }
  };

  return (
    <div className=" ">
      <ToastContainer />{" "}
      {loading ? (
        <div className=" flex items-center justify-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
        </div>
      ) : (
        <div className="flex flex-col  items-center">
          <div className="sm:w-[30%] w-[100%] px-2">
            <LazyImage src={bannerImage} alt="Spin Wheel Banner" className="rounded-xl" />
          </div>
          <h1 className="font-galada sm:text-3xl wheel-banner text-3xl my-4 text-center   bg-gradient-to-r from-customGradiantColor1 via-customGradiantColor3 to-customGradiantColor2 bg-clip-text text-transparent">
            {companyName} <br />
            Spin & Win
          </h1>

          {/* ---------------- Spin Wheel --------------------  */}

          <div className=" ">
            <div className="wheel-container">
              <div className="outer-wheel">
                <div className="inner-wheel">
                  <div
                    className="front-wheel"
                    style={{
                      // transform: `rotate(${prizeNumber * (360 / prizes.length)}deg)`,

                      transform: `rotate(${rotationAngle}deg)`,
                      transition: "transform 5s ease-in-out",
                    }}
                  >
                    {prizes.map((prize, index) => (
                      <div
                        key={index}
                        className="wheel-section"
                        style={{
                          transform: `rotate(${
                            index * (360 / prizes.length)
                          }deg)`,
                        }}
                      >
                        <div className="prize ">
                          {/* <span className="prize-label  text-white">{prize.label}</span> */}

                          <LazyImage
                            src={prize.image}
                            alt={prize.label}
                            className="prize-image"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="wheel-pointer">
                    <img src={pointer} className="w-28" alt="Pointer" />
                  </div>
                  <div className="wheel-center">
                    <img
                      src={spinWheelLogo}
                      alt="Center Logo"
                      className="center-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ---------------- Spin Wheel --------------------  */}

          <div className="sm:mt-4 mt-1"></div>
          <button
            className="spin-button z-50  mt-4"
            onClick={() => handleSpinClick(spinWheelData?.spinWheel?.status)}
            // disabled={spinning}
          >
            Spin
          </button>

          {showLoginPopup && (
            <div className="popup-overlay">
              {/* <LoginModal
              closeModal={handleClosePopup}
              // spinWheelState={handleSpinWheelRotate}
            /> */}

              <div className="w-full max-w-md mx-auto p-4 sm:p-6">
                <div className="popup-content relative">
                  {/* Close Button */}
                  <button 
                    onClick={() => setShowLoginPopup(false)}
                    className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold z-10"
                  >
                    &times;
                  </button>

                  {/* Header Section */}
                  <div className="flex gap-3 sm:gap-5 items-center justify-center mb-4 sm:mb-6">
                    <div className="w-16 sm:w-20 flex-shrink-0">
                      <img src={spinWheelLogo} alt="" className="w-full h-auto" />
                    </div>
                    <h1 className="text-lg sm:text-xl lg:text-2xl text-center font-semibold leading-tight">
                      {companyName}
                    </h1>
                  </div>

                  <h2 className="sign-in-label text-center text-lg sm:text-xl font-medium mb-4 sm:mb-6">
                    Sign In to Spin
                  </h2>

                  <div className="flex flex-col gap-4 sm:gap-5">
                    {/* Name Input Field */}
                    <div className="text-left">
                      <label className="block text-[#5D6269] text-sm sm:text-base font-medium mb-2" htmlFor="name">
                        Enter your name
                      </label>
                      <input
                        type="text"
                        id="name"
                        readOnly={buttonStatus}
                        placeholder="Your full name"
                        className="w-full h-10 sm:h-12 focus:outline-none border px-3 sm:px-4 border-gray-400 rounded-md text-sm sm:text-base transition-all duration-200 focus:border-primaryColor focus:ring-2 focus:ring-primaryColor focus:ring-opacity-20"
                        onChange={(e) => {
                          const value = e.target.value;
                          const isValid = /^[A-Za-z.\s]*$/.test(value);
                          if (isValid) {
                            setName(value);
                          }
                        }}
                        value={name}
                      />
                    </div>

                    {/* Mobile Number Input Field */}
                    <div className="text-left">
                      <label className="block text-[#5D6269] text-sm sm:text-base font-medium mb-2" htmlFor="phone">
                        Enter your mobile number
                      </label>

                      <div className="flex gap-2 sm:gap-3 w-full">
                        {/* <div className="border flex py-2 sm:py-3 px-2 sm:px-3 gap-1 sm:gap-2 border-gray-400 rounded-md h-10 sm:h-12 items-center bg-gray-50">
                          <span className="text-sm sm:text-base">🇮🇳</span>
                          <span className="text-sm sm:text-base font-medium">+91</span>
                        </div> */}

                        <input
                          readOnly={buttonStatus}
                          type="text"
                          id="phone"
                          placeholder="Enter 10-digit number"
                          className="flex-1 h-10 sm:h-12 focus:outline-none border px-3 sm:px-4 border-gray-400 rounded-md text-sm sm:text-base transition-all duration-200 focus:border-primaryColor focus:ring-2 focus:ring-primaryColor focus:ring-opacity-20"
                          value={phoneNumber}
                          onChange={handlePhoneNumber}
                        />
                      </div>

                      {/* Terms and Conditions Checkbox */}
                      {!buttonStatus && (
                        <div className="mt-3 sm:mt-4">
                          <div className="flex items-start gap-2 sm:gap-3">
                            <input 
                              type="checkbox"
                              id="terms"
                              checked={isChecked}
                              onChange={() => setIsChecked(!isChecked)}
                              className="mt-0.5 h-4 w-4 sm:h-5 sm:w-5 text-primaryColor border-2 border-gray-300 rounded focus:ring-2 focus:ring-primaryColor"
                            />
                            <label htmlFor="terms" className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                              I agree to the{" "}
                              <span
                                className="text-blue-600 underline cursor-pointer hover:text-blue-800 transition-colors duration-200"
                                onClick={() => {
                                  handleTermsAndCondition();
                                }}
                              >
                                Terms and Conditions
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* OTP Section */}
                    {buttonStatus && (
                      <div className="space-y-3 sm:space-y-4">
                        {/* Resend OTP Section */}
                        <div className="text-center">
                          {isResendActive ? (
                            <p className="text-gray-500 text-sm sm:text-base">
                              Resend OTP ({`00:${resendTime < 10 ? `0${resendTime}` : resendTime}`})
                            </p>
                          ) : (
                            <button
                              onClick={() => handleResendOTP()}
                              className="text-primaryColor underline hover:text-primaryColor-dark transition-colors duration-200 text-sm sm:text-base font-medium"
                            >
                              Resend OTP
                            </button>
                          )}
                        </div>

                        {/* OTP Input Field */}
                        <div className="text-left">
                          <label className="block text-[#5D6269] text-sm sm:text-base font-medium mb-2" htmlFor="otp">
                            Enter OTP
                          </label>
                          <input
                            type="text"
                            id="otp"
                            placeholder="Enter 6-digit OTP"
                            className="w-full h-10 sm:h-12 focus:outline-none border px-3 sm:px-4 border-gray-400 rounded-md text-sm sm:text-base transition-all duration-200 focus:border-primaryColor focus:ring-2 focus:ring-primaryColor focus:ring-opacity-20 text-center font-mono tracking-widest"
                            value={otp}
                            onChange={handleOtp}
                            maxLength="6"
                          />
                        </div>
                      </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex justify-center pt-2 sm:pt-4">
                      {!buttonStatus ? (
                        <button
                          className={`${
                            !isChecked || !name.trim() || phoneNumber.length < 10 ? "bg-gray-400" : "bg-primaryColor hover:bg-primaryColor-dark"
                          } w-full sm:w-32 h-10 sm:h-12 rounded-md text-white font-semibold text-sm sm:text-base transition-all duration-200 transform ${
                            !isChecked || !name.trim() || phoneNumber.length < 10 ? "" : "hover:scale-105"
                          } disabled:opacity-50 disabled:cursor-not-allowed`}
                          onClick={() => sendOtp()}
                          disabled={!isChecked || !name.trim() || phoneNumber.length < 10 || buttonLoading}
                        >
                          {buttonLoading ? (
                            <div className="flex w-full items-center justify-center">
                              <div className="animate-spin rounded-full w-5 h-5 sm:w-6 sm:h-6 border-t-2 border-b-2 border-white"></div>
                            </div>
                          ) : (
                            "Get OTP"
                          )}
                        </button>
                      ) : (
                        <button
                          className="w-full sm:w-32 h-10 sm:h-12 bg-primaryColor hover:bg-primaryColor-dark rounded-md text-white font-semibold text-sm sm:text-base transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                          onClick={() => verifyOtp()}
                          disabled={isDisabled}
                        >
                          {isDisabled ? (
                            <div className="flex w-full items-center justify-center">
                              <div className="animate-spin rounded-full w-5 h-5 sm:w-6 sm:h-6 border-t-2 border-b-2 border-white"></div>
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <button
            className="text-xs pt-14 sm:pt-10 text-white cursor-pointer"
            onClick={() => handleTermsAndCondition()}
          >
            Terms and conditions
          </button>

          {/* -------  Terms and Conditions --------------  */}

          {showTermsAndConditionPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
              <div className="bg-white rounded-xl shadow-xl w-full sm:w-11/12 md:w-4/5 lg:w-3/5 xl:w-1/2 max-w-4xl p-4 sm:p-6 transform transition-all max-h-[90vh] overflow-y-auto">
                <div className="flex flex-col gap-3 sm:gap-4">
                  <div className="flex justify-between items-center">
                    <h1 className="font-semibold text-lg sm:text-xl md:text-2xl">
                      Terms and Conditions
                    </h1>
                    <button
                      onClick={() => handleUpdateTermsAndCondition()}
                      className="font-bold text-xl sm:text-2xl text-gray-600 hover:text-gray-800 p-1 hover:bg-gray-100 rounded-full transition-colors duration-200"
                    >
                      &times;
                    </button>
                  </div>

                  <div className="w-full">
                    <ReactQuill
                      value={termsAndCondition}
                      readOnly
                      modules={{ toolbar: false }}
                      className="focus:outline-none bg-[#F6F6F6] w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] p-2 rounded-xl border-none"
                    />
                  </div>
                  
                  {!agreeStatus ? (
                    <div className="flex justify-center pt-2 sm:pt-3">
                      <button
                        onClick={() => handleAgreeFromTermsAndCondition()}
                        className="w-24 sm:w-28 h-10 sm:h-12 rounded-lg bg-[#399E79] hover:bg-[#2d7a5f] text-white font-semibold text-sm sm:text-base transition-colors duration-200 shadow-md hover:shadow-lg"
                      >
                        Agree
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          )}

          {/* -------  Terms and Conditions --------------  */}

          {/* ---------------- win or loss popup --------------  */}

          {showWinOrLosePopup && (
            <div className="popup-overlay overflow-y-auto">
              <div className="popup-content-win-card flex flex-col max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl mx-4 sm:mx-auto my-4 sm:my-8 max-h-[90vh] overflow-y-auto relative">
                <button 
                  onClick={() => handleCloseWinPopup()}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold z-10"
                >
                  &times;
                </button>
                <div className="flex justify-between items-center mb-2">
                  <img className="w-8 sm:w-12" src={winDecoration} alt="" />
                  <img className="w-16 sm:w-20 md:w-24" src={spinWheelLogo} alt="" />
                  <img className="w-8 sm:w-12" src={winDecoration} alt="" />
                </div>

                <div className="text-center mb-4">
                  <h1 className="text-lg sm:text-xl md:text-2xl font-normal">
                    Hi, {finalResult?.userDataObj?.name}
                  </h1>
                </div>
                <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3">
                  <h1 className="text-lg sm:text-xl md:text-2xl font-galada">Your Spin</h1>
                  <img src={giftBox} alt="" className="w-5 sm:w-6" />
                </div>

                {finalResult?.resultObj?.result == true ? (
                  <div className="border-dashed border border-gray-300 p-2 sm:p-3 rounded-xl grid grid-cols-1 sm:grid-cols-2 items-center gap-2 sm:gap-3 mb-3">
                    <div className="flex flex-col items-center gap-1 sm:gap-2 justify-center">
                      <img
                        className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 object-contain"
                        src={finalResult?.resultObj?.giftImageUrl}
                        alt=""
                      />

                      <h1 className="text-xs sm:text-sm md:text-base prize-font font-semibold text-center">
                        {finalResult?.resultObj?.giftItem}
                      </h1>
                    </div>
                    <div className="flex justify-center">
                      {finalResult?.resultObj?.result == true ? (
                        <div className="w-full max-w-[120px] sm:max-w-[150px] border border-gray-200 shadow-md rounded-lg overflow-hidden">
                          <QRCode
                            value={finalResult?.resultObj?.winCode}
                            style={{
                              height: "auto",
                              maxWidth: "100%",
                              width: "100%",
                              padding: "6px",
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="border-dashed border border-gray-300 p-2 sm:p-3 rounded-xl mb-3">
                    <div className="flex flex-col items-center gap-1 sm:gap-2 justify-center">
                      <img
                        className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain"
                        src={finalResult?.resultObj?.giftImageUrl}
                        alt=""
                      />

                      <h1 className="text-sm sm:text-lg md:text-xl prize-font font-semibold text-center">
                        {finalResult?.resultObj?.giftItem}
                      </h1>
                    </div>
                  </div>
                )}

                <div className="mb-3">
                  <div className="w-full text-left">
                    <ReactQuill
                      value={
                        finalResult?.resultObj?.result == true
                          ? finalResult?.spData?.winInstruction
                          : finalResult?.spData?.loseInstruction
                      }
                      readOnly
                      modules={{ toolbar: false }}
                      style={{ borderStyle: "none" }}
                      className="custom-quill border-none outline-none focus:outline-none cursor-pointer w-full text-xs sm:text-sm"
                    />
                  </div>
                </div>

                {/* {finalResult?.resultObj?.result == true ? (
                  <div className="text-center mb-3">
                    <h1 className="font-semibold text-xs sm:text-sm">
                      Offer Expiry Date - {finalResult?.resultObj?.expiryDate}
                    </h1>
                  </div>
                ) : (
                  ""
                )} */}

                <div className="bg-gray-50 p-2 sm:p-3 md:p-4 rounded-lg border border-gray-200">
                  {(() => {
                    const referralList = JSON.parse(sessionStorage.getItem("referralsList") || "[]");
                    
                    // Only show referral form for winners
                    if (referralList.length === 0 && finalResult?.resultObj?.result == true) {
                      // Show referral form only for winners
                      return (
                        <>
                          <div className="mb-3 sm:mb-4 text-center">
                            <div className="text-primaryColor font-semibold text-sm sm:text-base md:text-lg mb-2 flex items-center justify-center">
                              Terms to Claim Your Prize
                            </div>
                            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed px-1">
                              To claim this prize, please provide 2 referral contacts below:
                            </p>
                          </div>

                          <div className="space-y-3 sm:space-y-4">
                    {/* First Referral */}
                    <div className="bg-white p-2 sm:p-3 md:p-4 rounded-lg border border-gray-100 shadow-sm">
                      <h4 className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3 flex items-center">
                        <span className="inline-flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 bg-primaryColor text-white text-xs rounded-full mr-2">1</span>
                        First Referral
                      </h4>
                      <div className="grid grid-cols-1 gap-2 sm:gap-3">
                        <div className="flex flex-col items-start">
                          <label className="block text-xs sm:text-sm font-medium text-gray-600 mb-1">
                            Full Name *
                          </label>
                          <input 
                            type="text" 
                            placeholder="Enter full name"
                            value={firstReferralName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[A-Za-z.\s]*$/.test(value);
                              if (isValid) {
                                setFirstReferralName(value);
                              }
                            }}
                            className="w-full px-2 py-1.5 sm:px-3 sm:py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent transition-all duration-200"
                          />
                        </div>
                        <div className="flex flex-col items-start">
                          <label className="block text-xs sm:text-sm font-medium text-gray-600 mb-1">
                            Phone Number *
                          </label>
                          <input 
                            type="tel"
                            placeholder="Enter phone number"
                            value={firstReferralPhone}
                            onChange={(e) => {
                              const newPhoneNumber = e.target.value.replace(/\D/g, "");
                              if (newPhoneNumber.length <= 10) {
                                setFirstReferralPhone(newPhoneNumber);
                              }
                            }}
                            className="w-full px-2 py-1.5 sm:px-3 sm:py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent transition-all duration-200"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Second Referral */}
                    <div className="bg-white p-2 sm:p-3 md:p-4 rounded-lg border border-gray-100 shadow-sm">
                      <h4 className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3 flex items-center">
                        <span className="inline-flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 bg-primaryColor text-white text-xs rounded-full mr-2">2</span>
                        Second Referral
                      </h4>
                      <div className="grid grid-cols-1 gap-2 sm:gap-3">
                        <div className="flex flex-col items-start">
                          <label className="block text-xs sm:text-sm font-medium text-gray-600 mb-1">
                            Full Name *
                          </label>
                          <input 
                            type="text" 
                            placeholder="Enter full name"
                            value={secondReferralName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[A-Za-z.\s]*$/.test(value);
                              if (isValid) {
                                setSecondReferralName(value);
                              }
                            }}
                            className="w-full px-2 py-1.5 sm:px-3 sm:py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent transition-all duration-200"
                          />
                        </div>
                        <div className="flex flex-col items-start">
                          <label className="block text-xs sm:text-sm font-medium text-gray-600 mb-1">
                            Phone Number *
                          </label>
                          <input 
                            type="tel" 
                            placeholder="Enter phone number"
                            value={secondReferralPhone}
                            onChange={(e) => {
                              const newPhoneNumber = e.target.value.replace(/\D/g, "");
                              if (newPhoneNumber.length <= 10) {
                                setSecondReferralPhone(newPhoneNumber);
                              }
                            }}
                            className="w-full px-2 py-1.5 sm:px-3 sm:py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-transparent transition-all duration-200"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="pt-2 sm:pt-3">
                      <button 
                        className="w-full bg-primaryColor text-white py-2 sm:py-2.5 md:py-3 px-4 rounded-lg text-sm sm:text-base font-medium hover:bg-opacity-90 transition-all duration-200 shadow-md hover:shadow-lg"
                        onClick={() => ReferralUserDetails()}
                      >
                        Submit Referral Details
                      </button>
                    </div>
                  </div>
                        </>
                      );
                    } else if (referralList.length === 0 && finalResult?.resultObj?.result == false) {
                      // For losers, show a message without referral form
                      return (
                        <div className="text-center py-8 sm:py-10">
                          <div className="mb-4">
                            <svg className="w-16 h-16 sm:w-20 sm:h-20 mx-auto text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
                            Better Luck Next Time!
                          </h2>
                          <p className="text-gray-600 text-sm sm:text-base mb-3">
                            Don't worry! You can spin again and win amazing prizes.
                          </p>
                          {/* <p className="text-gray-500 text-xs sm:text-sm">
                            Come back soon and try your luck again with different number!
                          </p> */}
                        </div>
                      );
                    } else {
                      // Show message content when referrals were already submitted
                      return (
                        <div className="text-center py-8 sm:py-10">
                          <div className="mb-4">
                            <svg className="w-16 h-16 sm:w-20 sm:h-20 mx-auto text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                            Thank You!
                          </h2>
                          <p className="text-gray-600 text-sm sm:text-base mb-4">
                            Thank you for providing referral details.
                            {finalResult?.resultObj?.result == true 
                              ? " Your prize will be processed soon!" 
                              : ""}
                          </p>
                          {/* <p className="text-gray-500 text-xs sm:text-sm">
                            You will receive a confirmation on your registered phone number.
                          </p> */}
                        </div>
                      );
                  }                  })()}
                </div>
              </div>
            </div>
          )}

          {/* ---------------- Testimonials Section --------------  */}
          {testimonials.length > 0 && (
          <div className="w-full max-w-6xl mx-auto mt-4 sm:mt-6 md:mt-8 px-3 sm:px-4 md:px-6">
            {/* Testimonials Toggle Button */}
            <div className="text-center mb-4 sm:mb-6">
              <button
                onClick={() => setShowTestimonials(!showTestimonials)}
                className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base md:text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out flex items-center gap-2 sm:gap-3 mx-auto"
              >
                <svg 
                  className="w-6 h-6" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" 
                  />
                </svg>
                {showTestimonials ? 'Hide' : 'Show'} Customer Reviews
                <svg 
                  className={`w-5 h-5 transform transition-transform duration-300 ${showTestimonials ? 'rotate-180' : 'rotate-0'}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m19 9-7 7-7-7" />
                </svg>
              </button>
            </div>

            {/* Testimonials Grid */}
            <div className={`testimonials-container transition-all duration-500 ease-in-out ${
              showTestimonials 
                ? 'max-h-none opacity-100 transform translate-y-0 overflow-visible' 
                : 'max-h-0 opacity-0 transform -translate-y-4 overflow-hidden'
            }`}>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6 pb-4 sm:pb-6 md:pb-8">
                {testimonials.map((testimonial) => (
                    <div
                      key={testimonial.id}
                      className="bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transform transition-all duration-300 ease-in-out p-4 sm:p-5 md:p-6 border border-gray-100 relative overflow-hidden"
                    >
                    {/* Background decoration */}
                    <div className="absolute top-0 right-0 w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-bl from-blue-100 to-purple-100 rounded-bl-full opacity-50"></div>
                    
                    {/* Quote icon */}
                    <div className="absolute top-3 left-3 sm:top-4 sm:left-4 text-blue-200">
                      <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
                      </svg>
                    </div>

                    {/* Rating Stars */}
                    <div className="flex items-center justify-end mb-3 sm:mb-4 relative z-10">
                      {[...Array(5)].map((_, index) => (
                        <svg
                          key={index}
                          className={`w-4 h-4 sm:w-5 sm:h-5 ${
                            index < testimonial.rating
                              ? 'text-yellow-400 fill-current'
                              : 'text-gray-300'
                          }`}
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                      <span className="ml-2 text-sm font-medium text-gray-600">
                        {testimonial.rating}/5
                      </span>
                    </div>

                    {/* Testimonial Text */}
                    <p className="text-gray-700 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4 relative z-10 min-h-[50px] sm:min-h-[60px]">
                      "{testimonial.testimonial}"
                    </p>

                    {/* User Info */}
                    <div className="flex items-center relative z-10">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-lg mr-2 sm:mr-3 shadow-md">
                        {testimonial.userName.charAt(0).toUpperCase()}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-800 text-xs sm:text-sm">
                          {testimonial.userName}
                        </h4>
                        <p className="text-xs text-gray-500">
                          {new Date(testimonial.createdTimestamp._seconds * 1000).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })}
                        </p>
                      </div>
                    </div>

                    {/* Verified badge */}
                    <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4">
                      <div className="bg-green-100 text-green-800 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-full text-xs font-medium flex items-center gap-1">
                        <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        Verified
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          )}

          {/* ---------------- win or loss popup --------------  */}

          {showPausePopup && (
            <div className="popup-overlay">
              <div className="popup-content ">
                <h1>
                  Spin Wheel is Not Available Right Now <br />
                  Try Again Later
                </h1>
              </div>{" "}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SpinWheel;
